import template from './insurance-quotes.html';
import { actions, selectors } from '../../../state';
import './insurance-quotes.global.css';

const ANALYTICS_EVENT = 'Clicked Get an Insurance Acquisition CTA';

export class InsuranceQuotesController {
  constructor($window, updStore) {
    'ngInject';
    Object.assign(this, {
      $window,
      updStore,
    });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  getQuote(zipCode) {
    const url = `https://www.libertymutual.com/updater-quote?src=aff_1sw_m_0124389_updater&MM_webID=0000022159&zipCode=${zipCode}`;
    this.$window.open(url, '_blank');
    this.updStore.dispatch(
      actions.analytics.track(ANALYTICS_EVENT, { 'Zip Code': zipCode })
    );
  }
}

export const InsuranceQuotesComponent = {
  template,
  controller: InsuranceQuotesController,
};

function mapStateToThis(state) {
  const move = selectors.current.move(state);

  return {
    zip: move.toAddress(state).zip,
  };
}
